var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTelephone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.281,
    height: 7.281,
    viewBox: "0 0 7.281 7.281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M7.073,5.145,5.48,4.463a.341.341,0,0,0-.4.1l-.705.862A5.271,5.271,0,0,1,1.857,2.9L2.719,2.2a.34.34,0,0,0,.1-.4L2.134.207a.344.344,0,0,0-.391-.2L.264.35A.341.341,0,0,0,0,.683a6.6,6.6,0,0,0,6.6,6.6.341.341,0,0,0,.333-.264l.341-1.479a.345.345,0,0,0-.2-.392Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0.64)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelephone);
export default __webpack_public_path__ + "static/media/icon-telephone.29ccb523548ddc57e0e6e20a5b3cf8d4.svg";
export { ForwardRef as ReactComponent };